const apiUrl = process.env.VUE_APP_ROOT_API

export default {
  apiUrl
}
